import { useRef } from "react";
import moment from "moment";
import { Flex, Grid, Label, Loader } from "@aws-amplify/ui-react";
import LocalizedStrings from "react-localization";
import { Edit } from "@mui/icons-material";

const EditableDateField = ({ label, value, fieldName, onChangeDate }) => {
  const inputRef = useRef(null);

  const handleEditClick = () => {
    inputRef.current?.showPicker?.();
    if (!inputRef.current?.showPicker) inputRef.current?.click();
  };

  const handleChange = (e) => {
    const newDate = e.target.value;
    if (newDate && onChangeDate) onChangeDate(fieldName, newDate);
  };

  return (
    <Grid>
      <Label>{label}</Label>
      <Flex gap="5px" alignItems="center">
        <span className="text-muted">
          {value ? moment(value).format("YYYY-MM-DD HH:mm:ss") : "N/A"}
        </span>
        {value && (
          <>
            <Edit
              color="action"
              fontSize="14"
              style={{ cursor: "pointer" }}
              onClick={handleEditClick}
            />
            <input
              ref={inputRef}
              type="datetime-local"
              style={{
                opacity: 0,
                position: "absolute",
                pointerEvents: "none",
              }}
              defaultValue={moment(value).format("YYYY-MM-DDTHH:mm")}
              onChange={handleChange}
            />
          </>
        )}
      </Flex>
    </Grid>
  );
};

const ExecutedOrderItem = ({ item, onChangeDate }) => {
  return (
    <Grid gap="25px" templateColumns={{ medium: "1fr 1fr 1fr" }}>
      <EditableDateField
        label={strings.executionStartedAt}
        value={item.executionStartedAt}
        fieldName="executionStartedAt"
        onChangeDate={onChangeDate}
      />
      <EditableDateField
        label={strings.executionEndedAt}
        value={item.executionEndedAt}
        fieldName="executionEndedAt"
        onChangeDate={onChangeDate}
      />
      <Grid>
        <Label>{strings.userExecutor}</Label>
        <span className="text-muted">
          {item.hasOwnProperty("userExecutorName") ? (
            item.userExecutorName
          ) : (
            <Loader />
          )}
        </span>
      </Grid>
    </Grid>
  );
};

const strings = new LocalizedStrings({
  es: {
    executedAt: "Fecha de Ejecución",
    executionStartedAt: "Fecha Inicio de Ejecución",
    executionEndedAt: "Fecha Final de Ejecución",
    userExecutor: "Ejecutor",
    observations: "Observaciones",
  },
});

export default ExecutedOrderItem;
